import React from 'react';
import { ActivityIndicator, Pressable, StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import { LinearGradient } from 'expo-linear-gradient';
import { GradientText } from './GradientText';
import { colors, controleLarge, gradients, radius, spacing, typography } from '../theme/tokens';
import { fleche } from '../i18n/sens';

export interface GradientOutlineButtonProps {
  label: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
  withArrow?: boolean;
  icon?: React.ReactNode; // icône optionnelle à gauche du label (ex. calendrier)
  testID?: string;
}

// Bouton à CONTOUR dégradé charte : bordure = LinearGradient, fond blanc, texte dégradé.
// Technique : un dégradé avec un padding (épaisseur de bordure) entoure un inner blanc.
export function GradientOutlineButton({
  label,
  onPress,
  disabled = false,
  loading = false,
  withArrow = false,
  icon,
  testID,
}: GradientOutlineButtonProps) {
  const inactive = disabled || loading;

  // Désactivé (hors chargement) : bordure + texte gris neutres (pas de dégradé délavé).
  if (disabled && !loading) {
    return (
      <Pressable testID={testID} accessibilityRole="button" accessibilityState={{ disabled: true }} disabled onPress={onPress} style={controleLarge}>
        <View style={[styles.inner, styles.disabledBorder]}>
          <Text style={styles.disabledLabel}>{label}</Text>
        </View>
      </Pressable>
    );
  }

  return (
    <Pressable
      testID={testID}
      accessibilityRole="button"
      accessibilityState={{ disabled: inactive, busy: loading }}
      disabled={inactive}
      onPress={onPress}
      style={controleLarge}
    >
      <LinearGradient colors={gradients.brand} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} style={styles.border}>
        <View style={styles.inner}>
          {loading ? (
            <ActivityIndicator testID={testID ? `${testID}-spinner` : undefined} color={colors.electric} />
          ) : (
            <>
              {icon ? <View style={styles.icon}>{icon}</View> : null}
              <GradientText style={styles.label}>{`${label}${withArrow ? `  ${fleche('→')}` : ''}`}</GradientText>
            </>
          )}
        </View>
      </LinearGradient>
    </Pressable>
  );
}

const BORDER = 1.5;

const styles = StyleSheet.create({
  border: { borderRadius: radius.pill, padding: BORDER },
  inner: {
    minHeight: 50,
    borderRadius: radius.pill,
    backgroundColor: colors.white,
    paddingHorizontal: spacing.xl,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: { marginEnd: spacing.sm },
  label: { fontSize: typography.bodyMd.size, fontWeight: '700' },
  disabledBorder: { borderWidth: 1, borderColor: colors.grey200 },
  disabledLabel: { fontSize: typography.bodyMd.size, fontWeight: '700', color: colors.disabledText },
});
